<ng-container *ngIf="centered">
  <div class="p-5 content-center">
    <mat-spinner [diameter]="diameter"></mat-spinner>
  </div>
</ng-container>
<ng-container *ngIf="!centered">
  <mat-spinner [diameter]="diameter"></mat-spinner>
</ng-container>
